import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';

export function useDeleteEICFTemplate() {
    const queryClient = useQueryClient();
    return useMutation<void, AppMedError, number>({
        mutationKey: [QueryKeys.eicfTemplates, 'delete'],
        mutationFn: (id) => EICFTemplatesApi.delete(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfTemplates] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfFacilityActiveTemplate] });
        },
    });
}
